// 种养品种方式
const BREED_METHOD_LIST = ["移栽", "育苗", "播种", "养殖", "投苗"];

export const BREED_METHOD_MAP = {
  agri: {
    1: BREED_METHOD_LIST[0],
    2: BREED_METHOD_LIST[1],
    3: BREED_METHOD_LIST[2],
  },
  forestry: {
    1: BREED_METHOD_LIST[0],
    2: BREED_METHOD_LIST[1],
    3: BREED_METHOD_LIST[2],
  },
  animal: {
    10: BREED_METHOD_LIST[3],
    11: BREED_METHOD_LIST[3],
    12: BREED_METHOD_LIST[3],
  },
  fishery: {
    20: BREED_METHOD_LIST[4],
  },
};

export const Nj_STATUS_TABS = [
  {
    label: "已下单",
    value: 0,
    color: "#FF8800",
  },
  {
    label: "处理中",
    value: 1,
    color: "#40C4FF",
  },
  {
    label: "已派单",
    value: 2,
    color: "#4C84FF",
  },
  {
    label: "待评价",
    value: 3,
    color: "#FFB800",
  },
  {
    label: "已完成",
    value: 4,
    color: "#64C3A4",
  },
  {
    label: "已关闭",
    value: -1,
    color: "#7D8EB1",
  },
];
